import {
  Action,
  ActionType,
  IPostConsentStatemenResponse,
} from "models/consentStatement/postConsentStatement";
import createReducer from "redux/createReducer";

export interface PostConsentStatementReducerType {
  loading: boolean;
  error?: string;
  postConsentStatementResponse?: IPostConsentStatemenResponse;
}

const defaultState: PostConsentStatementReducerType = {
  loading: false,
  error: undefined,
  postConsentStatementResponse: undefined,
};

export const postConsentStatementReducer =
  createReducer<PostConsentStatementReducerType>(defaultState, {
    [ActionType.POST_CONSENT_STATEMENT](
      state: PostConsentStatementReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.POST_CONSENT_STATEMENT_ERROR](
      state: PostConsentStatementReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.POST_CONSENT_STATEMENT_SUCCESS](
      state: PostConsentStatementReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        postConsentStatementResponse: action.payload,
      };
    },

    [ActionType.POST_CONSENT_STATEMENT_RESET](
      state: PostConsentStatementReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        postConsentStatementResponse: undefined,
      };
    },
  });
